(() => {
  'use strict';
  if (window.YK_ACTIVITY || window.Shopify?.designMode) return;
  const endpoint = 'https://plain-pine-1366.gayatrikartabu.workers.dev/analytics/events';
  const nativeFetch = window.fetch.bind(window);
  let enabled = false, visitorId, sessionId;
  const config = JSON.parse(document.getElementById('yk-activity-config')?.textContent || '{}');
  const uuid = () => crypto.randomUUID();
  function identity() {
    try {
      const value = JSON.parse(localStorage.getItem('yk_otp_verified') || 'null');
      return value?.expiresAt > Date.now() && value.proof ? value.proof : '';
    } catch { return ''; }
  }
  function track(name, fields = {}) {
    if (!enabled || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    const proof = identity();
    const payload = {visitorId, sessionId, proof, landingPath: trackedPagePath(), deviceType: /Mobi/.test(navigator.userAgent) ? 'mobile' : 'desktop', events: [{...fields, id: uuid(), name, at: Date.now(), path: trackedPagePath(), currency: config.currency}]};
    nativeFetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload), keepalive:true}).catch(() => {});
  }
  function trackedPagePath() {
    const pathname = location.pathname;
    if (!/^\/search\/?$/.test(pathname)) return pathname;
    const rawQuery = new URLSearchParams(location.search).get('q');
    if (!rawQuery || !rawQuery.trim()) return pathname;
    const keyword = rawQuery.trim().replace(/\s+/g, ' ').slice(0, 160);
    return '/search/' + encodeURIComponent(keyword).replace(/%20/g, '+');
  }
  const product = p => ({productId:String(p.product_id || p.id || ''), variantId:String(p.variant_id || ''), title:p.product_title || p.title || '', quantity:p.quantity || 1, valueMinor:p.final_line_price ?? p.price});
  function start() {
    if (enabled || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    try {
      visitorId = localStorage.getItem('yk_activity_visitor');
      if (!/^V[0-9a-f-]{36}$/i.test(visitorId || '')) {visitorId = 'V' + uuid(); localStorage.setItem('yk_activity_visitor', visitorId);}
      let session = JSON.parse(sessionStorage.getItem('yk_activity_session') || 'null');
      if (!session || Date.now() - session.at > 1800000) session = {id:uuid(), at:Date.now()};
      session.at = Date.now(); sessionId = session.id;
      sessionStorage.setItem('yk_activity_session', JSON.stringify(session));
    } catch { visitorId = 'V' + uuid(); sessionId = uuid(); }
    enabled = true;
    track('page_viewed');
    if (config.productId) track('product_viewed', config);
    if (config.collection) track('collection_viewed', {collection:config.collection});
    if (/\/cart\/?$/.test(location.pathname)) track('cart_viewed');
  }
  window.YK_ACTIVITY = {track};
  document.addEventListener('yk:otp-verified', () => track('login_verified'));
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!enabled || !link) return;
    try {
      const url = new URL(link.href, location.href);
      const handle = url.pathname.match(/\/products\/([^/]+)/)?.[1];
      if (url.origin !== location.origin || !handle) return;
      nativeFetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(decodeURIComponent(handle)) + '.js', {keepalive:true}).then(r => r.ok ? r.json() : null).then(p => {if(p) track('product_clicked', product(p));}).catch(() => {});
    } catch {}
  }, true);
  window.addEventListener('yk:wishlist-changed', event => {
    const {handle, added} = event.detail || {};
    if (!enabled || !handle) return;
    nativeFetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js').then(r => r.ok ? r.json() : null).then(p => {if (p) track(added ? 'wishlist_added' : 'wishlist_removed', product(p));}).catch(() => {});
  });
  window.fetch = function(...args) {
    const result = nativeFetch(...args);
    try {
      const url = new URL(typeof args[0] === 'string' ? args[0] : args[0]?.url, location.href);
      if (url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname)) {
        result.then(response => {if (response.ok) response.clone().json().then(data => (data.items || [data]).forEach(item => track('product_added_to_cart', product(item)))).catch(() => {});}).catch(() => {});
      }
    } catch {}
    return result;
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) enabled = false;
    else start();
  });
  if (window.Shopify?.customerPrivacy) start();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) start();});
})();
